// TODO: validate if we need this to include all cookies (like gtm, facebook pixel, etc.) or only source cookie
export interface CookieConsent {
  sourceTracking: boolean;
  timestamp: number;
}

const CONSENT_COOKIE_NAME = 'cookie_consent';

export const useCookieConsent = () => {
  const consentCookie = useCookie<CookieConsent>(CONSENT_COOKIE_NAME, {
    maxAge: 60 * 60 * 24 * 365, // 1 year
    sameSite: 'lax',
    secure: true,
    path: '/',
    default: () => ({
      sourceTracking: false,
      timestamp: 0,
    }),
  });

  const accept = () => {
    consentCookie.value = {
      sourceTracking: true,
      timestamp: Date.now(),
    };

    // Call the source cookie function from the plugin
    const { $setSourceCookie } = useNuxtApp();
    if ($setSourceCookie) {
      try {
        $setSourceCookie();
      } catch (error) {
        console.warn('Error calling setSourceCookie:', error);
      }
    }
  };

  const reject = () => {
    consentCookie.value = {
      sourceTracking: false,
      timestamp: Date.now(),
    };
  };

  const canTrackSource = computed(() => {
    return consentCookie.value.sourceTracking;
  });

  return {
    accept,
    reject,
    canTrackSource,
  };
};
